import React, { useEffect, useState } from "react";
import ProfileCard from "../common/profileCard";
import { Program, User } from "../../../core/types/types";
import { useDispatch, useSelector } from "react-redux";
import apiInstance from "../../../utility/apiInstance";
import RecruiterSidebar from "../common/recruiterSidebar";
import RecruiterStatusGate from "../common/recruiterStatusGate";
import AddStudentPopup from "./addStudentPopup";
import { backupRecruiter, setCredentials, updateUser } from "../../../core/redux/authSlice";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { Country, LevelOfEducation } from "../../../core/common/selectOption/json/selectOption";
import BulkUploadStudentsPopup from "./studentBulkUpload";

const RecruiterStudents = () => {
    const user = useSelector((state: any) => state.auth.user);
    const token = useSelector((state: any) => state.auth.token);
    const [students, setStudents] = useState<User[]>([]);
    const [addStudentPopup, setAddStudentPopup] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showBulkUpload, setShowBulkUpload] = useState(false);
    const handleBulkUploadComplete = (newStudents: User[]) => {
        setStudents(prev => [...prev, ...newStudents]);
      };

    const addStudentHandler = (student: User) => {
        setStudents([student, ...students]);
    };

    useEffect(() => {
        const fetchStudents = async () => {
            try {
                const res = await apiInstance.get(
                    `/api/users?where[and][0][role][equals]=student&where[and][1][agent][equals]=${user.id}`
                );
                setStudents(res.data.docs);
            } catch (err) {
                console.error("Failed to fetch students:", err);
            }
        };

        if (user?.id) fetchStudents();
    }, [user?.id]);

    const switchStudent = async (studentId: string | undefined) => {
        try {

            dispatch(backupRecruiter());

            const res = await apiInstance.get(
                `/api/recruiters/switch/${studentId}`
            );
            const { token, student } = res.data;

            if (token && student) {
               
                dispatch(setCredentials({ token, userId: student.id }));
                dispatch(updateUser(student));

                navigate(all_routes.studentDashboard);
            } else {
                console.error("Switch failed: No token or student returned");
            }
        } catch (err) {
            console.error("Failed to switch:", err);
        }
    };

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <RecruiterSidebar />
                        {/* sidebar */}
                        {
                            <div className="col-lg-9">
                            <RecruiterStatusGate>
                                <div className="page-title d-flex flex-wrap gap-3 align-items-center justify-content-between">
                                    <h5>All Students</h5>
                                    <div className="tab-list">
                                        <ul
                                            className="nav mb-0 gap-2"
                                            role="tablist"
                                        >
                                            <li
                                                className="nav-item mb-0"
                                                role="presentation"
                                            >
                                                <button
                                                    onClick={() => {
                                                        setAddStudentPopup(
                                                            true
                                                        );
                                                    }}
                                                    className="btn btn-primary font-heading icon-send-letter"
                                                >
                                                    Add Student 
                                                </button>
                                                
                                            </li>
                                            <li
                                                className="nav-item mb-0"
                                                role="presentation"
                                            >
                                                <button onClick={() => setShowBulkUpload(true)}
                                                    className="btn btn-primary font-heading icon-send-letter"

                                                >
                                                    Bulk Upload Students
                                                    </button>
                                                
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="alert alert-info d-flex align-items-start mt-3"
                                    role="alert"
                                    style={{ borderRadius: "8px" }}
                                >
                                    <i className="isax isax-info-circle me-2"></i>
                                    <div>
                                        To complete the student’s profile and
                                        submit their application, switch to the
                                        student dashboard. Click the{" "}
                                        <i
                                            style={{
                                                fontSize: "15px",
                                            }}
                                            className="isax isax-eye"
                                        ></i>{" "}
                                        icon under <strong>Actions</strong> to
                                        switch. Once the details are updated,
                                        you can switch back to your{" "}
                                        <strong>recruiter dashboard</strong>{" "}
                                        anytime.
                                    </div>
                                </div>

                                <div className="table-responsive custom-table">
                                    <table className="table">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Student ID</th>
                                                <th>Email</th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Nationality</th>
                                                <th>Highest Education</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {students && students?.length > 0
                                                ? students?.map(
                                                      (item: User) => (
                                                          <tr>
                                                              <td>
                                                                  <div className="text-primary fw-bold">
                                                                      {
                                                                          item?.studentId
                                                                      }
                                                                  </div>
                                                              </td>
                                                              <td>
                                                                  {" "}
                                                                  {item?.email ||
                                                                      "-"}
                                                              </td>
                                                              <td>
                                                                  {" "}
                                                                  {item?.firstName ||
                                                                      "-"}
                                                              </td>
                                                              <td>
                                                                  {" "}
                                                                  {item?.lastName ||
                                                                      "-"}
                                                              </td>
                                                              <td>
                                                                  {" "}
                                                                  {item.countryOfCitizenship
                                                                      ? Country.filter(
                                                                            (
                                                                                c
                                                                            ) =>
                                                                                c.value ===
                                                                                item.countryOfCitizenship
                                                                        )?.[0]
                                                                            .label
                                                                      : "-"}
                                                              </td>
                                                              <td>
                                                                  {" "}
                                                                  {item
                                                                      .educationHistory
                                                                      ?.highestEducation
                                                                      ?.level
                                                                      ? LevelOfEducation.filter(
                                                                            (
                                                                                c
                                                                            ) =>
                                                                                c.value ===
                                                                                item
                                                                                    .educationHistory
                                                                                    ?.highestEducation
                                                                                    ?.level
                                                                        )?.[0]
                                                                            .label
                                                                      : "-"}
                                                              </td>
                                                              <td>
                                                                  <i
                                                                      className="isax isax-eye me-2 cursor-pointer"
                                                                      onClick={() =>
                                                                          switchStudent(
                                                                              item.id
                                                                          )
                                                                      }
                                                                  ></i>
                                                              </td>
                                                          </tr>
                                                      )
                                                  )
                                                : "No students"}
                                        </tbody>
                                    </table>
                                </div>
                            </RecruiterStatusGate>
                            </div>
                        }
                    </div>
                </div>
                <AddStudentPopup
                    show={addStudentPopup}
                    onClose={() => setAddStudentPopup(false)}
                    addStudentHandler={addStudentHandler}
                />
                <BulkUploadStudentsPopup
                    show={showBulkUpload}
                    onClose={() => setShowBulkUpload(false)}
                    onBulkUploadComplete={handleBulkUploadComplete}
                    />
            </div>
        </>
    );
};

export default RecruiterStudents;
